/** When automatic top-up's threshold is larger than the pack it would buy. */
export const autoTopUpThresholdExceedsPackMessage =
  "Threshold must be less than the purchased pack!" as const;

export const enterThresholdMessage = "Enter a threshold." as const;
